module.exports = __webpack_public_path__ + "static/media/zeya_not_happy.92cb706b.png";